import { AuthProvider } from "./lib/AuthContext";
import { UserStatsProvider } from "./lib/UserStatsContext";
import { BadgeToastProvider } from "./components/BadgeToast";
import AuthGate from "./components/AuthGate";
import MainApp from "./components/MainApp";
import CookieConsent from "./components/CookieConsent";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <UserStatsProvider>
          <BadgeToastProvider>
            <AuthGate>
              <MainApp />
            </AuthGate>
            <CookieConsent />
          </BadgeToastProvider>
        </UserStatsProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
